const inputs = [
  { type: 'email', name: 'email', placeholder: 'Email' },
  { type: 'password', name: 'password', placeholder: 'Password' },
  { type: 'password', name: 'confirmPassword', placeholder: 'Confirm Password' }
]

const Account = ({ onChange, ...props }) => (
  <div className='col-5'>
    <div className='settings-title col-12 center'>Account Details</div>
    <form className='form' onSubmit={props.onSubmit}>
      { inputs.map(e =>
        <input key={e.name} {...{ ...e, onChange }} className='col-12' value={props[e.name]} />
      ) }
      <button className='col-12'>Update Email</button>
    </form>
  </div>
)

export default Account
